import { createCsatSurveyViewDriver } from './csat-survey-view/driver';
export var createCsatSurveyDriver = function (wrapper) {
    var csatSurveyView = createCsatSurveyViewDriver(wrapper);
    return {
        csatSurveyView: csatSurveyView,
    };
};
//# sourceMappingURL=driver.js.map